import * as angular from "angular";

export class WhiteLabelDataProvider {
    private theme: any;
    private isLeaderView: any;

    constructor($cookies: any, __app_type: string, __env: any) {
        this.theme = $cookies.get("theme");
        this.isLeaderView = __app_type == "LEADER";
    }

    hasCustomTheme(): boolean {
        return this.theme && this.theme != "default";
    }

    getLogoUrl(): string {
        if (this.hasCustomTheme()) {
            return "/themes/" + this.theme + "/logo.png";
        } else {
            return this.isLeaderView
                ? "/img/ecanvasser/ecanvasser-leader-logo-vertical-alt.png"
                : "/img/ecanvasser/rev-logo-full-color-vert.svg";
        }
    }

    getMiniLogoUrl(): string {
        if (this.hasCustomTheme()) {
            return "/themes/" + this.theme + "/favicon/mstile-150x150.png";
        } else {
            return this.isLeaderView
                ? "/img/ecanvasser/favicon/android-chrome-leader-192x192.png"
                : "/img/ecanvasser/favicon/android-chrome-192x192.png";
        }
    }

    getHomepageLogoUrl(): string {
        if (this.hasCustomTheme()) {
            return "/themes/" + this.theme + "/homepage-logo.png";
        } else {
            return this.isLeaderView
                ? "/img/ecanvasser/ecanvasser-leader-logo-vertical-alt.png"
                : "/img/ecanvasser/rev-logo-full-color-vert.svg";
        }
    }
}

angular
    .module("vcDataProvider")
    .service("WhiteLabelDataProvider", WhiteLabelDataProvider);
